export default Object.freeze({
  JSON: 'json',
  AVRO: 'avro',
  CSV: 'csv',
  PARQUET: 'parquet',
});
